"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessege = ErrorMessege;
const jsx_runtime_1 = require("react/jsx-runtime");
const colors_1 = require("../../common/colors");
const AppText_1 = require("../AppText");
function ErrorMessege({ msg, isError }) {
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: isError && ((0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: colors_1.Colors.red, padding: 1, children: msg })) }));
}
